import { Badge } from "@/components/ui/badge";
import { TEAM_ROLES } from "@/features/onboarding/data";

interface RoleBadgeProps {
	role: string;
}

export function RoleBadge({ role }: RoleBadgeProps) {
	const option = TEAM_ROLES.find((item) => item.id === role);

	if (!option) {
		return role ? <Badge variant="outline">{role}</Badge> : null;
	}

	const Icon = option.icon;
	return (
		<Badge variant="secondary" className="role-badge">
			<Icon />
			{option.label}
		</Badge>
	);
}
